import { render, staticRenderFns } from "./CopySniippet.vue?vue&type=template&id=3d15baa7&"
import script from "./CopySniippet.vue?vue&type=script&lang=js&"
export * from "./CopySniippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports